/**
 * Strict parser for a price typed into the Item Prices grid.
 *
 * Accepts "1500", "12.5", "1,500", "1,500.25" and a leading "$". Anything else
 * (decimal commas like "1,5", "1.500,00", text, a lone "$") returns `null`
 * instead of guessing: the grid used to save `parseFloat(text) || 0`, which
 * stored "1,500" as 1 and "$1500" as 0 straight into the price catalogue while
 * the review dialog showed the raw text as if it had been accepted.
 */
const PRICE_RE = /^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?$/

export const parsePriceInput = (raw: string): number | null => {
  const cleaned = raw.trim().replace(/^\$/, '').replace(/\s/g, '')
  if (!PRICE_RE.test(cleaned)) return null
  return Number(cleaned.replace(/,/g, ''))
}
